import { createApp, defineAsyncComponent } from "vue";

import SvgVue from 'svg-vue3'
import VueLazyLoad from 'vue3-lazyload'

const app = createApp({
  components: {
    Slider: defineAsyncComponent(() => import('./common/Slider.vue')),
    PhotoGallery: defineAsyncComponent(() => import('./blocks/PhotoGallery.vue')),
    SocialIcons: defineAsyncComponent(() => import('./common/SocialMediaIcons.vue')),
    ReviewSlider: defineAsyncComponent(() => import('./common/ReviewSlider.vue')),
    // ProjectGallery: defineAsyncComponent(() => import('./common/ProjectGallery.vue')),
  },

  data: () => ({
    openMenu: '',
    scrollPosition: 0,
    alertsOpen: false,
    activeFaq: '',
    activeMobileNavGroup: 1,
  }),

  computed: {
    mobileMenu () {
      return this.openMenu === 'mobileMenu'
    },
    isScrolling () {
      return this.scrollPosition > 0
    },
  },

  methods: {
    toggleMenu (menu) {
      this.openMenu = (this.openMenu != menu ? menu : '')
    },
    setMobileNavGroup (item) {
      this.activeMobileNavGroup = this.activeMobileNavGroup != item ? item : ''
    },
    handleScroll (event) {
      this.scrollPosition = window.pageYOffset != undefined ? window.pageYOffset : window.scrollY
    },
    setSidebar (sidebar) {
      this.openSidebar = sidebar
    },
  },

  created() {
    window.addEventListener("scroll", this.handleScroll);
  },

  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },

})

app.use(VueLazyLoad, {
  preLoad: 1.3,
  error: '/images/blank.svg',
  loading: '/images/blank.svg',
  attempt: 1
})

app.use(SvgVue, {
  svgPath: 'resources/svg',
  extract: false,
  svgoSettings: [
      { removeTitle: true },
      { removeViewBox: false },
      { removeDimensions: true }
  ]
})

app.mount("#app")
